<template>
  <div
    :id="id"
    :style="{ width: '90%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "chartsData"],
  data() {
    return {
      msg: "同比环比",
    };
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let _this = this;
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        grid: {
          top: "50px",
          left: "50px",
          right: "15px",
          bottom: "80px",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter: function (params) {
            let result = params[0].name + "<br>";
            params.forEach(function (item) {
              result +=
                item.marker +
                " " +
                item.seriesName +
                " : " +
                item.value +
                _this.chartsData.unit +
                "</br>";
            });
            return result;
          },
        },
        legend: {
          top: "1%",
          right: "2%",
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            rotate: 20,
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
          data: this.chartsData.xData,
        },
        yAxis: {
          type: "value",
          name: `单位(${this.chartsData.unit})`,
          nameTextStyle: {
            color: "#377AFE",
            fontSize: 14,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          axisLabel: {
            color: "#999",
            fontSize: 14,
            // formatter: '{value} kw·h'
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "#EBEBEB",
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: this.chartsData.xData.length >= 15 ? true : false,
            startValue: 0, //数据窗口范围的起始数值
            endValue: 14,
            xAxisIndex: [0],
            handleSize: 30,
            height: 10, //组件高度
            bottom: 5, //右边的距离
          },
        ],
        series: [
          {
            name: this.id == "myCharts" ? "今年" : "本期",
            type: "bar",
            barMinHeight: 2,
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#fccb05",
                  },
                  {
                    offset: 1,
                    color: "#f5804d",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              borderRadius: 12,
            },
            barWidth: 20,
            data: this.chartsData.yearArr,
          },
          {
            name: this.id == "myCharts" ? "去年" : "上期",
            type: "bar",
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#248ff7",
                  },
                  {
                    offset: 1,
                    color: "#6851f1",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              borderRadius: 11,
            },
            barWidth: 20,
            data: this.chartsData.lastYearArr,
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>
